import { Component } from '@angular/core';
import { OverviewService } from 'src/app/services/overview/overview.service';
import { SidebarService } from 'src/app/services/sidebar/sidebar.service';
import { Router } from '@angular/router';
import { Roles, isOperator } from 'src/app/auth/roles';
import { RefreshStateArea, RefreshStateService } from 'src/app/services/refresh-state/refresh-state.service';

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  currentRole: string | null = "";
  roles = Roles;

  constructor(
    public overviewService: OverviewService,
    public sidebarService: SidebarService,
    private router: Router,
    private refreshState: RefreshStateService,
  ) { }

  get homeMenuRoute(): string {
    return this.isOperatorRole ? '/dashboard' : '/home';
  }

  get settingsMenuRoute(): string {
    return this.isOperatorRole ? '/settings/profile' : '/settings';
  }

  async resetHomeScreen(event?: Event) {
    event?.preventDefault();
    const area: RefreshStateArea = this.isOperatorRole ? 'dashboard' : 'home';
    await this.navigateToMenu(area, this.homeMenuRoute, true);
  }

  async onNavClick(
    area: Extract<RefreshStateArea, 'analytics' | 'reports' | 'settings'>,
    event?: Event,
  ) {
    event?.preventDefault();
    const target = area === 'settings' ? this.settingsMenuRoute : `/${area}`;
    await this.navigateToMenu(area, target);
  }

  ngOnInit(): void {
    this.currentRole = localStorage.getItem('role');
  }

  get isOperatorRole(): boolean {
    return isOperator(this.currentRole);
  }

  isCurrentArea(area: RefreshStateArea): boolean {
    const path = this.router.url.split('?')[0];
    if (area === 'home') {
      return path.startsWith('/home') || path.startsWith('/workflow-runtime');
    }
    if (area === 'dashboard') {
      return path.startsWith('/dashboard') ||
        path.startsWith('/workflow-runtime') ||
        path.startsWith('/form-details');
    }
    return path.startsWith(`/${area}`);
  }

  private async navigateToMenu(area: RefreshStateArea, target: string, isHome = false): Promise<void> {
    const shouldReset = this.isCurrentArea(area);
    if (shouldReset) {
      this.refreshState.resetArea(area);
      if (isHome) this.overviewService.resetToHome();
    }
    this.sidebarService.closeSidebar();

    try {
      await this.router.navigateByUrl(target);
    } finally {
      if (shouldReset) this.refreshState.finishAreaReset(area);
    }
  }
}
